import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { FilterParams, FunctionalAsset, SortDirection } from '@synergy/models';

import { AccountListItemDto } from '../models/dto/account-list-item-dto';
import { SupplierDetailDto } from '../models/dto/supplier-detail-dto';
import { SupplierMeta } from '../models/supplier-meta';
import { SupplierSpecialOfferDto } from '../models/dto/supplier-special-offer-dto';

export class SupplierApi {
    constructor(protected baseUrl: string) {}

    public getSuppliers = (
        params: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<AccountListItemDto, SupplierMeta>>> =>
        safeRequest(
            () =>
                request.get<PaginatedResponse<AccountListItemDto, SupplierMeta>>(`${this.baseUrl}/suppliers`, {
                    params,
                }),
            response => response.data
        );

    public getSupplierDetail = (id: number): Promise<ApiResult<SupplierDetailDto>> =>
        safeRequest(
            () => request.get<SupplierDetailDto>(`${this.baseUrl}/suppliers/${id}`),
            response => response.data
        );

    public getSpecialOffers = (
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<SupplierSpecialOfferDto>>> => {
        const params = searchParams ?? new URLSearchParams();
        params.set(FilterParams.SortBy, 'validFrom');
        params.set(FilterParams.SortDirection, SortDirection.Ascending);
        params.set(FilterParams.PageSize, '15');
        return safeRequest(
            () => request.get(`${this.baseUrl}/special-offers`, { params }),
            response => response.data
        );
    };

    public getFunctionalAssets = (supplierId: number): Promise<ApiResult<FunctionalAsset[]>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/suppliers/${supplierId}/functional-assets`),
            response => response.data
        );
    };
}
